import {ParagraphText} from '@thryvlabs/maverick'
import React from 'react'
import {useLocation} from 'react-router'
import dayjs from 'dayjs'
import {toast} from 'react-toastify'
import {useAsync} from '../../utils/use-async'
import {ADD_ON} from '../../utils/addons-data'
import {useAuthClient} from '../../utils/use-auth-client'
import CallSection from './call-section'
import {useUserRoles} from '../../utils/use-user-roles'
import {addDays} from 'date-fns'
import {fetchProductGroups} from '../../app-store/productRules/productRulesThunk'
import {useDispatch, useSelector} from 'react-redux'
import {selectAddonCodeMap} from '../../app-store/productRules/productRulesSlice'
import {MC_2_0_SIGPREMIERPLANS} from '../../utils/constants'

const ONBOARDING_REQUIRED_4PLAN_UPGRADES = [
  'addon-4-mc-m2m',
  'addon-4-mc-semi',
  'addon-4-mcpro-m2m',
]

const RADIO_LANGUAGE_PREFERENCES = [
  {name: 'Yes', value: true},
  {name: 'No', value: false},
]

export default function BookAppointments({
  selectedCentersAndApps,
  saveCallData,
  setDisplayCreativeCallModal,
  setDisplayThryvSuccessServicesCall,
  setDisplayKickOffCall,
  setOnboardingConfirmed,
  setCreativeConfirmed,
  setThryvSuccessServicesConfirmed,
  setIsApptSkipped,
  selectedCountry,
  selectedAddons,
  selectedIndustryId,
  onboardingCallDate,
  useAccountOwnerInfo,
  accountInformation,
  isApptSkipped,
  setKickoffApptId,
  kickoffApptId,
  setCreativeApptId,
  setThryvSuccessServicesApptId,
  creativeApptId,
  thryvSuccessServicesApptId,
  setOnboardingCallDate,
  creativeCallDate,
  setCreativeCallDate,
  thryvSuccessServicesCallDate,
  setThryvSuccessServicesCallDate,
  onboardingConfirmed,
  creativeConfirmed,
  thryvSuccessServicesConfirmed,
  displayKickOffCall,
  displayCreativeCallModal,
  displayThryvSuccessServicesCall,
  upgradeAccountInfo,
  isSyncUpgrade,
  input,
  purchaseIntent,
  industryCategoryType,
  useFormData,
  isKickoffNotRequiredCC,
  isThryvStarterOnboarding,
  defaultCentersAndApps,
  order5NUId,
  captureOrderNewUpgrade,
  setOrder5CreativeApptId,
  setOrder5OnboardingApptId,
  setOrder5ThryvSuccessServicesApptId,
  isNewTLMCAccessible,
  keapAccount,
}) {
  const dispatch = useDispatch()

  // selectedCountry.isoValue is always present; accountInformation.country may
  // be missing when coming from the AccountSetup (new CC account) flow.
  const countryCode =
    accountInformation?.country || selectedCountry?.isoValue || 'US'

  const [isLoading, setIsLoading] = React.useState(false)
  const [selectedKickoffService, setSelectedKickoffService] =
    React.useState(null)
  const [selectedCreativeService, setSelectedCreativeService] =
    React.useState(null)
  const [
    selectedThryvSuccessServicesService,
    setSelectedThryvSuccessServicesService,
  ] = React.useState(null)
  const [kickoffLanguagePreference, setKickoffLanguagePreference] =
    React.useState(RADIO_LANGUAGE_PREFERENCES[1])
  const [creativeLanguagePreference, setCreativeLanguagePreference] =
    React.useState(RADIO_LANGUAGE_PREFERENCES[1])
  const [
    thryvSuccessServicesLanguagePreference,
    setThryvSuccessServicesLanguagePreference,
  ] = React.useState(RADIO_LANGUAGE_PREFERENCES[1])
  const [noneCustomVideoCreativeItem, setNoneCustomVideoCreativeItem] =
    React.useState(false)
  const [isFormReady, setIsFormReady] = React.useState(false)
  const {centers, apps} = selectedCentersAndApps || {}
  const {pathname} = useLocation()
  const {roles} = useUserRoles()
  const {run} = useAsync({
    status: 'pending',
  })

  const isInputInvalid = () => {
    return (
      !input.firstNameInput ||
      !input.lastNameInput ||
      !input.emailInput ||
      !input.mobileInput
    )
  }

  const isNewOrder =
    pathname === '/order/new' &&
    selectedIndustryId !== 13 &&
    selectedIndustryId !== 12

  const isThryvLeadsOrSeoIncluded =
    centers?.some(({name}) => name === 'Thryv Leads') ||
    apps?.some(({name}) => name === 'Thryv Leads') ||
    centers?.some(
      ({name}) =>
        name.includes('SEO') &&
        name !== 'AEO & SEO' &&
        name !== 'SEO Keywords' &&
        name !== 'AEO & SEO PowerBoost',
    ) ||
    apps?.some(
      ({name}) =>
        name.includes('SEO') &&
        name !== 'AEO & SEO' &&
        name !== 'SEO Keywords' &&
        name !== 'AEO & SEO PowerBoost',
    )

  const isUpgrade = pathname === '/order/upgrade'
  const isRestrictedAccessHIPPASelected = selectedCentersAndApps?.apps?.some(
    product =>
      product.name === ADD_ON.add_ons['Restricted Access'].label ||
      product.name === ADD_ON.add_ons['HIPAA'].label,
  )
  const isMCSelected = selectedCentersAndApps?.centers?.some(
    product =>
      product.name === 'Marketing Center Pro' ||
      product.name === 'Marketing Center Plus',
  )
  const hasBCSelected = selectedCentersAndApps?.centers?.some(
    product =>
      product.name === 'Business Center Professional' ||
      product.name === 'Business Center Plus' ||
      product.name === 'Business Center Unlimited',
  )
  const hasBC6Selected = selectedCentersAndApps?.centers?.some(
    product => product.code === 'bc-6-thryv-m2m',
  )
  const hasCCSelected = selectedCentersAndApps?.centers?.some(
    product =>
      product.code === 'cc_pro-5-thryv-m2m' ||
      product.code === 'cc_basicpls-5-thryv-m2m' ||
      product.code === 'cc_plus-5-thryv-m2m',
  )
  const hasSignatureSelected = selectedCentersAndApps?.centers?.some(product =>
    MC_2_0_SIGPREMIERPLANS.includes(product.code),
  )
  const newProducts = [
    ...(selectedCentersAndApps?.apps || []),
    ...(selectedCentersAndApps?.centers || []),
  ].filter(
    ({code}) =>
      defaultCentersAndApps?.apps?.every(
        ({code: defaultCode}) => defaultCode !== code,
      ) &&
      defaultCentersAndApps?.centers?.every(
        ({code: defaultCode}) => defaultCode !== code,
      ),
  )
  const isOnlyNewSocialAdsSelected =
    newProducts.length === 1 && newProducts[0].name.includes('Social Ads')

  const isUsSpanishOptionAvailable =
    selectedCountry.isoValue === 'US' &&
    (hasSignatureSelected ||
      ((hasBCSelected || isMCSelected || hasBC6Selected) && hasCCSelected)) &&
    !isOnlyNewSocialAdsSelected

  const skipAppointment = callType => {
    setIsApptSkipped(prev => ({...prev, [callType]: true}))
  }

  const getLanguagePreference = callType => {
    if (callType === 'kickoff') {
      return kickoffLanguagePreference.value ? 'es' : 'en'
    }
    if (callType === 'creative') {
      return creativeLanguagePreference.value ? 'es' : 'en'
    }
    if (callType === 'thryv-success-services') {
      return thryvSuccessServicesLanguagePreference.value ? 'es' : 'en'
    }
  }

  const getCreativeCallMinDate = () => {
    const _date = onboardingCallDate?.ISODate
      ? new Date(onboardingCallDate?.ISODate)
      : new Date()
    _date.setDate(_date.getDate() + 1)
    return dayjs(_date).toISOString()
  }

  const getThryvSuccessServicesCallMinDate = () => {
    return addDays(new Date(), 30).toISOString()
  }

  const client = useAuthClient()
  const addonCodeMap = useSelector(selectAddonCodeMap)

  const [scheduleOffsetDetails, setScheduleOffsetDetails] = React.useState([])
  React.useEffect(() => {
    async function fetchScheduleOffsetDays() {
      try {
        const response = await client('cc/order/schedule-offset-days')
        if (response) setScheduleOffsetDetails(response)
      } catch (ex) {
        // non-fatal; minDate falls back to default 2-day offset
        console.log('Error ::', JSON.stringify(ex))
      }
    }
    fetchScheduleOffsetDays()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const pre5SeoOffsetStartDay = React.useMemo(() => {
    const detail = scheduleOffsetDetails.find(
      d => d.product_code === 'addon-4-seobase-m2m',
    )
    return detail?.offset_start_day ?? null
  }, [scheduleOffsetDetails])

  const confirmOnboard = async () => {
    try {
      if (isInputInvalid()) {
        useFormData.trigger(['firstName', 'lastName', 'email', 'mobile'])
        return
      }
      if (
        !onboardingCallDate?.timeZoneId ||
        !onboardingCallDate?.selectedServiceId ||
        !onboardingCallDate?.selectedStaffId ||
        !onboardingCallDate?.ISODate ||
        !onboardingCallDate?.startDateTime
      ) {
        toast.error('Please select a date and time for the Thryv Kickoff Call.')
        return
      }
      useFormData.clearErrors()
      setIsLoading(true)
      const apptData = {
        firstName: useAccountOwnerInfo
          ? accountInformation.firstName
          : input.firstNameInput,
        lastName: useAccountOwnerInfo
          ? accountInformation.lastName
          : input.lastNameInput,
        email: useAccountOwnerInfo
          ? accountInformation.email
          : input.emailInput,
        phone: useAccountOwnerInfo
          ? accountInformation.mobile
          : input.mobileInput,
        company: accountInformation.company,
        isKeapClientPortalReq: roles.includes('PartnerOps') ? true : false,
        onboarding: {
          timeZone: onboardingCallDate.timeZoneId,
          serviceId: onboardingCallDate.selectedServiceId,
          staffId: onboardingCallDate.selectedStaffId,
          startTime: onboardingCallDate.ISODate,
          thryvBookingDate: onboardingCallDate.startDateTime,
          isAus: countryCode === 'AU',
          isNZ: countryCode === 'NZ',
          country: countryCode,
          isApptHold: true,
        },
      }
      const {apptId} = await client('plans/onboarding', {data: apptData})
      if (apptId) {
        apptData.appointment_type = 'onboarding'
        captureAppointment(apptData, apptId)
      }

      setIsLoading(false)
      setKickoffApptId(apptId)
      setOnboardingConfirmed(true)
      toast.success('Thryv Kickoff Call Confirmed')
    } catch (responseError) {
      setIsLoading(false)
      if (responseError.status !== 400) {
        throw responseError
      }
      responseError.errors.forEach(({message}) => toast.error(message))
    }
  }

  const resetOnboard = () => {
    setOnboardingCallDate(null)
    setKickoffApptId(null)
    setKickoffLanguagePreference(RADIO_LANGUAGE_PREFERENCES[1])
    resetCreative()
  }

  const getSelectedAddons = () => {
    let checkList = []
    if (selectedCentersAndApps) {
      let allSelectedCentersAndApps = [
        ...selectedCentersAndApps.centers,
        ...selectedCentersAndApps.apps,
        ...selectedCentersAndApps.oneTimes,
      ]
      checkList = allSelectedCentersAndApps
        .filter(({alreadyIncluded}) => !alreadyIncluded)
        .flatMap(item => {
          let entNames = []
          if (isNewOrder) {
            entNames = item.entitlements
              ? item.entitlements.map(e => e.name)
              : []
            return [item.name, ...entNames]
          }
          if (item.entitlements?.length > 0) {
            const newEntitlements = item.entitlements.filter(
              ({alreadyIncluded}) => !alreadyIncluded,
            )
            entNames = newEntitlements.map(e => e.name)
          }
          return [item.name, ...entNames]
        })
    } else {
      const filteredSelectedAddons = selectedAddons?.filter(
        ({planCode, product}) =>
          !upgradeAccountInfo.addOns.some(
            ({addOnCode, name}) => addOnCode === planCode || name === product,
          ),
      )
      checkList = filteredSelectedAddons?.map(({product}) => product)
    }
    checkList = checkList.filter(item => {
      if (item === 'Professionally Designed Website') {
        const alreadyHadWebsite = defaultCentersAndApps?.centers?.some(
          product =>
            product?.entitlements?.some(
              e => e.name === 'Professionally Designed Website',
            ),
        )
        return !alreadyHadWebsite
      }
      return true
    })
    return checkList
  }

  React.useEffect(() => {
    const checkList = getSelectedAddons()
    const handleDisplayCreativeCallModal = () => {
      // FULSAS-11317: Creative Call removed for all products.
      // These products now trigger a Kickoff Call instead.
      const _addons = []
      setNoneCustomVideoCreativeItem(
        handleOtherThanCustomVideo(_addons, checkList),
      )
      return checkList?.some(item => _addons.includes(item)) || false
    }
    const result = handleDisplayCreativeCallModal()

    setDisplayCreativeCallModal(result)
    useFormData.setValue('showCreativeCall', result)

    if (selectedIndustryId === 13) {
      setDisplayCreativeCallModal(result)
    }

    if (checkList?.includes('Strategic Content Creation')) {
      setDisplayThryvSuccessServicesCall(true)
      useFormData.setValue('showThryvSuccessServicesCall', true)

      if (checkList?.length === 1) {
        setDisplayKickOffCall(false)
      }
    }
    // FULSAS -704 Begins
    if (selectedAddons) {
      const newAddons = selectedAddons.filter(
        ({planCode}) =>
          !accountInformation?.addOns?.some(
            ({addOnCode}) => planCode === addOnCode,
          ) &&
          planCode !== accountInformation?.selectedPackage &&
          planCode !== 'rc-4-thryv-m2m',
      )

      const newStrategicContentCreation = newAddons.find(
        ({planCode}) => planCode === 'addon-4-stratcontent-m2m',
      )
      if (newStrategicContentCreation) {
        setDisplayThryvSuccessServicesCall(true)
        useFormData.setValue('showThryvSuccessServicesCall', true)

        if (newAddons?.length === 1) {
          setDisplayKickOffCall(false)
        }
      }

      const isExistingMarketingCenter = accountInformation?.addOns?.find(
        addon =>
          addon.tempLineActionCode === 'Update' &&
          (addon.addOnCode === 'addon-4-mcpro-m2m' ||
            addon.addOnCode === 'addon-4-mc-m2m'),
      )

      const isGrowthPackageAdded = selectedAddons.find(
        addon =>
          addon.tempLineActionCode === 'New' &&
          (addon.planCode === 'addon-4-mcstartgr-m2m' ||
            addon.planCode === 'addon-4-mcexpangr-m2m'),
      )
      // is4VNewSEOExist check is added as for new seo kickoff call is mandatory
      let is4VNewSEO = selectedAddons.find(
        item =>
          ['addon-4-seobase-m2m'].includes(item?.planCode) &&
          item.tempLineActionCode === 'New',
      )

      // isThryvLead check added as for thryvLead kickoff call is mandatory
      let isThryvLeads
      if (selectedAddons) {
        isThryvLeads = selectedAddons.find(
          item =>
            item?.planCode.includes('-tl-') &&
            item.tempLineActionCode === 'New',
        )
      }
      const isNewMarketingCenter = selectedAddons?.find(item => {
        return (
          (item?.planCode === 'addon-4-mc-m2m' ||
            item?.planCode === 'addon-4-mcpro-m2m') &&
          item.tempLineActionCode === 'New'
        )
      })
      const is4VNewLL = selectedAddons?.find(item => {
        return (
          ['addon-4-leadslift-m2m'].includes(item?.planCode) &&
          item.tempLineActionCode === 'New'
        )
      })
      const isV4NewThryvSocialPosts = selectedAddons?.find(item => {
        return (
          ['addon-4-mc-socialcontentgen-m2m'].includes(item?.planCode) &&
          item.tempLineActionCode === 'New'
        )
      })
      const isV4NewSocialAds = selectedAddons?.find(item => {
        return (
          [
            'addon-4-socialadsbronze-m2m',
            'addon-4-socialadssilver-m2m',
            'addon-4-socialadsgold-m2m',
          ].includes(item?.planCode) && item.tempLineActionCode === 'New'
        )
      })
      const isV4ExistingSocialAds = accountInformation?.addOns?.find(
        addon =>
          addon.tempLineActionCode === 'Update' &&
          [
            'addon-4-socialadsbronze-m2m',
            'addon-4-socialadssilver-m2m',
            'addon-4-socialadsgold-m2m',
          ].includes(addon.addOnCode),
      )
      let kickOffCallConditionMet = false
      if (isNewMarketingCenter) {
        setDisplayKickOffCall(true)
        kickOffCallConditionMet = true
        return
      }
      if (isV4NewSocialAds && !isV4ExistingSocialAds) {
        setDisplayKickOffCall(true)
        kickOffCallConditionMet = true
        return
      }
      if (isV4NewSocialAds && !isV4ExistingSocialAds) {
        setDisplayKickOffCall(true)
        kickOffCallConditionMet = true
        return
      }
      if (is4VNewSEO) {
        setDisplayKickOffCall(true)
        kickOffCallConditionMet = true
        return
      }
      if (isThryvLeads && isNewTLMCAccessible) {
        kickOffCallConditionMet = true
        setDisplayKickOffCall(true)
        return
      }
      if (is4VNewLL) {
        kickOffCallConditionMet = true
        setDisplayKickOffCall(true)
        return
      }
      if (isV4NewThryvSocialPosts) {
        kickOffCallConditionMet = true
        setDisplayKickOffCall(true)
        return
      }
      if (isExistingMarketingCenter && isGrowthPackageAdded) {
        kickOffCallConditionMet = true
        setDisplayKickOffCall(false)
      }
      // FULSAS-11317: website/logo/photo/video 4.0 products now require kickoff call
      const is4VNewWebsite = selectedAddons?.find(
        item =>
          ['addon-4-website-m2m', 'ent-4-website-free'].includes(
            item?.planCode,
          ) && item.tempLineActionCode === 'New',
      )
      const is4VNewWebsiteExtras = selectedAddons?.find(
        item =>
          [
            'addon-ot-4-extra-website-pages',
            'logo-plan',
            'addon-ot-4-logo', // FULSAS-11673: actual Recurly code for Logo Pre-5.0
            'addon-ot-4-photo',
          ].includes(item?.planCode) && item.tempLineActionCode === 'New',
      )
      const is4VNewCreativeToKickoff = selectedAddons?.find(
        item =>
          [
            'ent-4-custvideo',
            'ent-4-socialcontentgen',
            'addon-4-vidviews-m2m',
          ].includes(item?.planCode) && item.tempLineActionCode === 'New',
      )
      if (is4VNewWebsite || is4VNewWebsiteExtras || is4VNewCreativeToKickoff) {
        kickOffCallConditionMet = true
        setDisplayKickOffCall(true)
        return
      }
      if (!kickOffCallConditionMet) {
        setDisplayKickOffCall(false)
      }
    }
    // FULSAS -704 Ends
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedAddons,
    useFormData.setValue,
    roles,
    selectedIndustryId,
    selectedCentersAndApps,
  ])

  React.useEffect(() => {
    dispatch(fetchProductGroups({client}))
  }, [dispatch, client])

  const is4MCSelected = selectedAddons?.some(({planCode}) =>
    ONBOARDING_REQUIRED_4PLAN_UPGRADES.includes(planCode),
  )
  const isMCAlreadyIncluded =
    !selectedCentersAndApps &&
    upgradeAccountInfo?.addOns.some(({addOnCode}) =>
      ONBOARDING_REQUIRED_4PLAN_UPGRADES.includes(addOnCode),
    )
  const isOnboardingRequired4Upgrade =
    isUpgrade && is4MCSelected && !isMCAlreadyIncluded
  const isLegacyUsSpanishOptionAvailable =
    selectedCountry.isoValue === 'US' && isOnboardingRequired4Upgrade
  const isUsSpanishOptionAvailableAllFlows =
    isUsSpanishOptionAvailable || isLegacyUsSpanishOptionAvailable

  const shouldEnableCreativeCallModal = () => {
    if (isNewOrder && (isKickoffNotRequiredCC || isApptSkipped.kickoff)) {
      return true
    }
    if (!isNewOrder && displayKickOffCall === false) {
      return true
    }
    if (isOnboardingRequired4Upgrade && !onboardingConfirmed) {
      return false
    }
    if (isUpgrade && !isSyncUpgrade && !selectedCentersAndApps) {
      return true
    }
    return (
      (purchaseIntent.firstPurchaseIntent &&
        purchaseIntent.secondPurchaseIntent &&
        purchaseIntent.thirdPurchaseIntent &&
        onboardingConfirmed) ||
      isApptSkipped.kickoff
    )
  }

  const handleOtherThanCustomVideo = (list, selected) => {
    const newList = list.filter(
      x => x !== ADD_ON.entitlements['Custom Video'].label,
    )

    return selected?.some(_item => newList.includes(_item))
  }

  const confirmCreative = async () => {
    try {
      if (!creativeCallDate && selectedCentersAndApps) return
      if (isInputInvalid()) {
        useFormData.trigger(['firstName', 'lastName', 'email', 'mobile'])
        return
      }
      if (
        !creativeCallDate?.timeZoneId ||
        !creativeCallDate?.selectedServiceId ||
        !creativeCallDate?.selectedStaffId ||
        !creativeCallDate?.ISODate ||
        !creativeCallDate?.startDateTime
      ) {
        toast.error(
          'Please select a date and time for the Creative Consultation.',
        )
        return
      }
      useFormData.clearErrors()
      setIsLoading(true)
      const apptData = {
        firstName: useAccountOwnerInfo
          ? accountInformation.firstName
          : input.firstNameInput,
        lastName: useAccountOwnerInfo
          ? accountInformation.lastName
          : input.lastNameInput,
        email: useAccountOwnerInfo
          ? accountInformation.email
          : input.emailInput,
        phone: useAccountOwnerInfo
          ? accountInformation.mobile
          : input.mobileInput,
        company: accountInformation.company,
        isKeapClientPortalReq: roles.includes('PartnerOps') ? true : false,
        creative: {
          timeZone: creativeCallDate.timeZoneId,
          serviceId: creativeCallDate.selectedServiceId,
          staffId: creativeCallDate.selectedStaffId,
          startTime: creativeCallDate.ISODate,
          thryvBookingDate: creativeCallDate.startDateTime,
          isAus: countryCode === 'AU',
          isNZ: countryCode === 'NZ',
          country: countryCode,
          isApptHold: true,
        },
      }
      const {apptId} = await client('plans/creative', {data: apptData})
      if (apptId) {
        apptData.appointment_type = 'creative'
        captureAppointment(apptData, apptId)
      }
      setIsLoading(false)
      setCreativeApptId(apptId)
      setCreativeConfirmed(true)
      toast.success('Creative Call Confirmed')
    } catch (responseError) {
      setIsLoading(false)
      if (responseError.status !== 400) {
        throw responseError
      }
      responseError.errors.forEach(({message}) => toast.error(message))
    }
  }

  const confirmThryvSuccessServices = async () => {
    try {
      if (!thryvSuccessServicesCallDate && selectedCentersAndApps) return
      if (isInputInvalid()) {
        useFormData.trigger(['firstName', 'lastName', 'email', 'mobile'])
        return
      }
      if (
        !thryvSuccessServicesCallDate?.timeZoneId ||
        !thryvSuccessServicesCallDate?.selectedServiceId ||
        !thryvSuccessServicesCallDate?.selectedStaffId ||
        !thryvSuccessServicesCallDate?.ISODate ||
        !thryvSuccessServicesCallDate?.startDateTime
      ) {
        toast.error(
          'Please select a date and time for the Thryv Success Services Call.',
        )
        return
      }
      useFormData.clearErrors()
      setIsLoading(true)
      const apptData = {
        firstName: useAccountOwnerInfo
          ? accountInformation.firstName
          : input.firstNameInput,
        lastName: useAccountOwnerInfo
          ? accountInformation.lastName
          : input.lastNameInput,
        email: useAccountOwnerInfo
          ? accountInformation.email
          : input.emailInput,
        phone: useAccountOwnerInfo
          ? accountInformation.mobile
          : input.mobileInput,
        company: accountInformation.company,
        onboarding: {
          timeZone: thryvSuccessServicesCallDate.timeZoneId,
          serviceId: thryvSuccessServicesCallDate.selectedServiceId,
          staffId: thryvSuccessServicesCallDate.selectedStaffId,
          startTime: thryvSuccessServicesCallDate.ISODate,
          thryvBookingDate: thryvSuccessServicesCallDate.startDateTime,
          isAus: countryCode === 'AU',
          isNZ: countryCode === 'NZ',
          country: countryCode,
          isApptHold: true,
        },
      }
      const {apptId} = await client('plans/onboarding', {
        data: apptData,
      })
      if (apptId) {
        apptData.appointment_type = 'thryv-success-services'
        captureAppointment(apptData, apptId)
      }
      setIsLoading(false)
      setThryvSuccessServicesApptId(apptId)
      setThryvSuccessServicesConfirmed(true)
      toast.success('Thryv Success Services Call Confirmed')
    } catch (responseError) {
      setIsLoading(false)
      if (responseError.status !== 400) {
        throw responseError
      }
      responseError.errors.forEach(({message}) => toast.error(message))
    }
  }

  const captureAppointment = async (data, apptId) => {
    console.log('new', data)
    const createAppointModel = []
    const dataRecord = {
      onboarding: data.onboarding,
      creative: data.creative,
      'thryv-success-services': data.onboarding,
    }
    const resolvedData = dataRecord[data.appointment_type]
    const appointmentObj = {
      order_id: order5NUId,
      schedule_status: 'Scheduled',
      appointment_type: data.appointment_type,
      timezone: resolvedData.timeZone,
      appt_id: apptId,
      date: resolvedData.thryvBookingDate.split('T')[0],
      time: resolvedData.thryvBookingDate.split('T')[1],
      title: 'Meeting Connect',
      duration: 30,
      service_id: resolvedData.serviceId,
      staff_id: resolvedData.staffId,
      interaction: 'call Interaction',
      zoomURL: 'https://www.zoom.com',
      create_user: null,
      update_user: null,
    }
    createAppointModel.push(appointmentObj)
    console.log(createAppointModel)
    try {
      let result
      result = await run(
        client('ordercapture/services/createAppointment', {
          data: createAppointModel,
          method: 'POST',
        }),
      )
      if (result.Success) {
        if (data.appointment_type === 'creative') {
          setOrder5CreativeApptId(apptId)
        } else if (data.appointment_type === 'onboarding') {
          setOrder5OnboardingApptId(apptId)
        } else if (data.appointment_type === 'thryv-success-services') {
          setOrder5ThryvSuccessServicesApptId(apptId)
        }
        const contextData = {
          appointment_type: data.appointment_type,
          apptId: apptId,
        }
        captureOrderNewUpgrade(
          'capture-appointment',
          'new-upgrade',
          contextData,
        )
      } else {
        console.log(result.message)
      }
    } catch (error) {
      if (error.status !== 400) {
        console.log('error in captureAppointment', error)
        // throw error
      }
      if (error.errors) {
        console.log('error in captureAppointment', error)
        // throw error
      }
    }
  }

  const resetCreative = () => {
    setCreativeCallDate(null)
    setCreativeApptId(null)
    setCreativeConfirmed(false)
    setCreativeLanguagePreference(RADIO_LANGUAGE_PREFERENCES[1])
  }

  const resetThryvSuccessServices = () => {
    setThryvSuccessServicesCallDate(null)
    setThryvSuccessServicesApptId(null)
    setThryvSuccessServicesConfirmed(false)
    setThryvSuccessServicesLanguagePreference(RADIO_LANGUAGE_PREFERENCES[1])
  }

  const cancelAppointment = async (callType, id) => {
    if (callType === 'kickoff') {
      setKickoffApptId(null)
      setKickoffLanguagePreference(RADIO_LANGUAGE_PREFERENCES[1])
      if (isApptSkipped.kickoff) {
        setIsApptSkipped(prev => ({...prev, kickoff: false}))
        return
      }
      setOnboardingConfirmed(false)
      setOnboardingCallDate(null)
    } else if (callType === 'creative') {
      setCreativeApptId(null)
      setCreativeLanguagePreference(RADIO_LANGUAGE_PREFERENCES[1])
      if (isApptSkipped.creative) {
        setIsApptSkipped(prev => ({...prev, creative: false}))
        return
      }
      setCreativeConfirmed(false)
      setCreativeCallDate(null)
    } else if (callType === 'thryv-success-services') {
      setThryvSuccessServicesApptId(null)
      setThryvSuccessServicesLanguagePreference(RADIO_LANGUAGE_PREFERENCES[1])
      if (isApptSkipped['thryv-success-services']) {
        setIsApptSkipped(prev => ({...prev, 'thryv-success-services': false}))
        return
      }
      setThryvSuccessServicesConfirmed(false)
      setThryvSuccessServicesCallDate(null)
    }

    const typesRecord = {
      kickoff: 'onboarding',
      creative: 'creative',
      'thryv-success-services': 'thryv-success-services',
    }

    const data = {
      type: typesRecord[callType],
      demoApptId: id,
      country: selectedCountry.isoValue,
    }

    const urls = {
      kickoff: 'plans/onboarding',
      creative: 'plans/creative',
      'thryv-success-services': 'plans/thryv-success-services',
    }

    try {
      const url = urls[callType]
      await client(url, {data, method: 'DELETE'})
      cancelAppointmentOrder(data.type, id)
    } catch {
      toast.error('error cancelling appt')
    }
  }

  const cancelAppointmentOrder = async (appointment_type, apptId) => {
    const appointmentObj = {
      order_id: order5NUId,
      schedule_status: 'Cancelled',
      appointment_type: appointment_type,
      appt_id: apptId,
    }
    try {
      // const data = appointmentObj
      const result = await run(
        client('ordercapture/services/updateScheduledAppointment', {
          data: appointmentObj,
          method: 'PUT',
        }),
      )
      if (result.success) {
        if (appointment_type === 'creative') {
          setOrder5CreativeApptId(null)
        } else if (appointment_type === 'onboarding') {
          setOrder5OnboardingApptId(null)
        } else if (appointment_type === 'thryv-success-services') {
          setOrder5ThryvSuccessServicesApptId(null)
        }
        const contextData = {
          appointment_type: appointment_type,
          apptId: null,
        }
        captureOrderNewUpgrade(
          'capture-appointment',
          'new-upgrade',
          contextData,
        )
      } else {
        console.log(result.message)
      }
    } catch (error) {
      if (error.status !== 400) {
        console.log('error in cancelling Appointment', error)
        // throw error
      }
      if (error.errors) {
        console.log('error in cancelling Appointment', error)
        // throw error
      }
    }
  }

  const includeAddonsCodes = (url, callType) => {
    const existingCentersAndApps = defaultCentersAndApps
      ? [
          ...defaultCentersAndApps.centers.map(center => ({
            ...center,
            planType: 'center',
          })),
          ...defaultCentersAndApps.apps,
        ]
      : []

    const allCentersAndApps =
      selectedCentersAndApps &&
      [
        ...existingCentersAndApps,
        ...selectedCentersAndApps.centers,
        ...selectedCentersAndApps.apps,
        ...selectedCentersAndApps.centers
          .filter(({code}) => !code.startsWith('cc_'))
          .flatMap(item => item.entitlements),
        ...selectedCentersAndApps.oneTimes.filter(
          // FULSAS-11317: addon-5-custvid also needs to be included for kickoff call scheduling
          ({code}) =>
            code === 'thryvlogo4' ||
            code === 'thryv5page' ||
            code === 'addon-5-custvid',
        ),
      ]
        .filter(item => item !== undefined && item !== null)
        .filter((currentItem, currentIndex, entireArray) => {
          const firstIndexWithSameCode = entireArray.findIndex(
            item => item.code === currentItem?.code,
          )

          return currentIndex === firstIndexWithSameCode
        })
        .filter(({alreadyIncluded}) => !alreadyIncluded)

    const onboardingAddons = ['HIPAA', ...(addonCodeMap.RestrictedAccess || [])]
    if (!selectedCentersAndApps) {
      onboardingAddons.push(
        'Thryv Leads',
        'Marketing Center',
        'SEO Money Back Guarantee',
        'SEO Non-Guaranteed',
        'AEO & SEO',
        'Social Ads',
        'Workforce Center Plus',
        'Insurance',
        'Electrical',
        'HVAC',
        'Plumbing',
        'Roofing',
        'Keap Max',
        'Leads Lift',
        'Thryv Social Posts',
      )
    } else {
      if (callType === 'kickoff') {
        onboardingAddons.push(
          ...(addonCodeMap.ThryvLeads || []),
          ...(addonCodeMap.MarketingCenter || []),
          ...(addonCodeMap.SEO || []),
          ...(addonCodeMap.SocialAds || []),
          ...(addonCodeMap.WorkforceCenter || []),
          ...(addonCodeMap.HomeServices || []),
          ...(addonCodeMap.Keap || []),
          ...(addonCodeMap.LeadsLift || []),
          ...(addonCodeMap.ThryvSocialPosts || []),
          // FULSAS-11317: website/logo products now trigger kickoff call instead of creative call
          ...(addonCodeMap.Website || []),
          ...(addonCodeMap.Logo || []),
        )
        if (selectedCentersAndApps)
          onboardingAddons.push(...(addonCodeMap.BusinessCenter || []))
      }
      if (callType === 'creative') {
        if (selectedCentersAndApps) {
          onboardingAddons.push(
            ...(addonCodeMap.Website || []),
            ...(addonCodeMap.Logo || []),
            ...(addonCodeMap.SEO || []),
          )
        } else if (
          selectedAddons?.some(item => addonCodeMap.SEO?.includes(item.code))
        ) {
          onboardingAddons.push(...(addonCodeMap.SEO || []))
        }
      }

      if (callType === 'thryv-success-services') {
        onboardingAddons.push(...(addonCodeMap.ThryvSuccessServices || []))
      }
    }

    const newAddons =
      selectedAddons?.filter(
        ({type, planCode}) =>
          type !== 'selectedPlan' &&
          upgradeAccountInfo?.addOns?.every(
            ({addOnCode}) => addOnCode !== planCode,
          ),
      ) || []

    const getCodes = (items, codeAccessor) =>
      items.reduce((codes, item) => {
        const code = codeAccessor(item)
        if (onboardingAddons.includes(code)) {
          codes.push(code)
        }
        return codes
      }, [])
    const getCodes4 = (items, codeAccessor) =>
      items.reduce((codes, item) => {
        const name = codeAccessor(item)
        if (onboardingAddons.includes(name)) {
          codes.push(name)
        }
        return codes
      }, [])
    const codes = selectedCentersAndApps
      ? getCodes(allCentersAndApps, item => item.code)
      : getCodes4(newAddons, item => {
          if (
            item.product.toLowerCase().includes('marketing center') &&
            !item.product.toLowerCase().includes('foundation')
          ) {
            return 'Marketing Center'
          }
          if (item.product.toLowerCase().includes('social ads')) {
            return 'Social Ads'
          }
          if (
            item.product.toLowerCase().includes('strategic content creation')
          ) {
            return 'Strategic Content Creation'
          }
          return item.product
        })

    return codes.length > 0
      ? selectedCentersAndApps
        ? `${url}&productGroupCodes=${encodeURIComponent(codes.join(','))}`
        : `${url}&addons=${encodeURIComponent(codes.join(','))}`
      : url
  }

  React.useEffect(() => {
    if (isFormReady) {
      useFormData.trigger(['firstName', 'lastName', 'email', 'mobile'])
    } else {
      setIsFormReady(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    input.firstNameInput,
    input.lastNameInput,
    input.emailInput,
    input.mobileInput,
    isFormReady,
  ])

  return (
    <div className="pl-4">
      {' '}
      {(displayKickOffCall || displayCreativeCallModal) && (
        <ParagraphText variant="lg" className="font-weight-bold">
          {selectedCentersAndApps ? 'Schedule Call' : 'SCHEDULE CALLS'}
        </ParagraphText>
      )}
      <div
        className={`${selectedCentersAndApps && 'd-block pr-4'}`}
        style={{columnGap: '20px'}}
      >
        {displayKickOffCall && (
          <CallSection
            apptData={{
              callType: 'kickoff',
              callDate: onboardingCallDate,
              callConfirmed: onboardingConfirmed,
              languagePreference: kickoffLanguagePreference,
              setSelectedService: setSelectedKickoffService,
              selectedService: selectedKickoffService,
              isApptSkipped: isApptSkipped.kickoff,
              cancelAppointment: cancelAppointment,
              confirmAppointment: confirmOnboard,
              resetAppointment: resetOnboard,
              skipAppointment: skipAppointment,
              apptId: kickoffApptId,
              saveCallData: saveCallData,
              setLanguagePreference: setKickoffLanguagePreference,
              getLanguagePreference: getLanguagePreference,
              industryCategoryType: industryCategoryType,
              displayKickOffCall,
              displayCreativeCallModal,
              isOnboardingRequired4Upgrade,
              isThryvStarterOnboarding,
              country: selectedCountry.isoValue,
            }}
            defaultCentersAndApps={defaultCentersAndApps}
            selectedCentersAndApps={selectedCentersAndApps}
            upgradeAccountInfo={upgradeAccountInfo}
            selectedAddons={selectedAddons}
            isUpgrade={isUpgrade}
            isSyncUpgrade={isSyncUpgrade}
            isLoading={isLoading}
            shouldEnableCreativeCallModal={shouldEnableCreativeCallModal}
            includeAddonsCodes={includeAddonsCodes}
            accountInformation={accountInformation}
            isMCSelected={isMCSelected}
            isRestrictedAccessHIPPASelected={isRestrictedAccessHIPPASelected}
            noneCustomVideoCreativeItem={noneCustomVideoCreativeItem}
            isNewOrder={isNewOrder}
            isThryvLeadsOrSeoIncluded={isThryvLeadsOrSeoIncluded}
            isUsSpanishOptionAvailable={isUsSpanishOptionAvailableAllFlows}
            errors={useFormData.errors}
            isNewTLMCAccessible={isNewTLMCAccessible}
            keapAccount={keapAccount}
            isMCAlreadyIncluded={isMCAlreadyIncluded}
            pre5SeoOffsetStartDay={pre5SeoOffsetStartDay}
          />
        )}
        {displayCreativeCallModal && (
          <CallSection
            apptData={{
              callType: 'creative',
              callDate: creativeCallDate,
              callConfirmed: creativeConfirmed,
              languagePreference: creativeLanguagePreference,
              setSelectedService: setSelectedCreativeService,
              selectedService: selectedCreativeService,
              isApptSkipped: isApptSkipped.creative,
              cancelAppointment: cancelAppointment,
              confirmAppointment: confirmCreative,
              resetAppointment: resetCreative,
              skipAppointment: skipAppointment,
              apptId: creativeApptId,
              saveCallData: saveCallData,
              setLanguagePreference: setCreativeLanguagePreference,
              getLanguagePreference: getLanguagePreference,
              industryCategoryType: industryCategoryType,
              displayKickOffCall,
              displayCreativeCallModal,
              isOnboardingRequired4Upgrade,
              country: selectedCountry.isoValue,
            }}
            defaultDate={getCreativeCallMinDate}
            defaultCentersAndApps={defaultCentersAndApps}
            selectedCentersAndApps={selectedCentersAndApps}
            selectedAddons={selectedAddons}
            isUpgrade={isUpgrade}
            isSyncUpgrade={isSyncUpgrade}
            isLoading={isLoading}
            shouldEnableCreativeCallModal={shouldEnableCreativeCallModal}
            includeAddonsCodes={includeAddonsCodes}
            accountInformation={accountInformation}
            isRestrictedAccessHIPPASelected={isRestrictedAccessHIPPASelected}
            noneCustomVideoCreativeItem={noneCustomVideoCreativeItem}
            isNewOrder={isNewOrder}
            isThryvLeadsOrSeoIncluded={isThryvLeadsOrSeoIncluded}
            isUsSpanishOptionAvailable={isUsSpanishOptionAvailable}
            register={useFormData.register}
            errors={useFormData.errors}
            onboardingCallDate={onboardingCallDate}
            upgradeAccountInfo={upgradeAccountInfo}
            isNewTLMCAccessible={isNewTLMCAccessible}
            keapAccount={keapAccount}
          />
        )}

        {displayThryvSuccessServicesCall && (
          <CallSection
            apptData={{
              callType: 'thryv-success-services',
              callDate: thryvSuccessServicesCallDate,
              callConfirmed: thryvSuccessServicesConfirmed,
              languagePreference: thryvSuccessServicesLanguagePreference,
              setSelectedService: setSelectedThryvSuccessServicesService,
              selectedService: selectedThryvSuccessServicesService,
              isApptSkipped: isApptSkipped['thryv-success-services'],
              cancelAppointment: cancelAppointment,
              confirmAppointment: confirmThryvSuccessServices,
              resetAppointment: resetThryvSuccessServices,
              skipAppointment: skipAppointment,
              apptId: thryvSuccessServicesApptId,
              saveCallData: saveCallData,
              setLanguagePreference: setThryvSuccessServicesLanguagePreference,
              getLanguagePreference: getLanguagePreference,
              industryCategoryType: industryCategoryType,
              displayKickOffCall,
              displayCreativeCallModal,
              displayThryvSuccessServicesCall,
              isOnboardingRequired4Upgrade,
              country: selectedCountry.isoValue,
            }}
            defaultDate={getThryvSuccessServicesCallMinDate}
            defaultCentersAndApps={defaultCentersAndApps}
            selectedCentersAndApps={selectedCentersAndApps}
            selectedAddons={selectedAddons}
            isUpgrade={isUpgrade}
            isSyncUpgrade={isSyncUpgrade}
            isLoading={isLoading}
            shouldEnableCreativeCallModal={shouldEnableCreativeCallModal}
            includeAddonsCodes={includeAddonsCodes}
            accountInformation={accountInformation}
            isRestrictedAccessHIPPASelected={isRestrictedAccessHIPPASelected}
            noneCustomVideoCreativeItem={noneCustomVideoCreativeItem}
            isNewOrder={isNewOrder}
            isThryvLeadsOrSeoIncluded={isThryvLeadsOrSeoIncluded}
            isUsSpanishOptionAvailable={isUsSpanishOptionAvailable}
            register={useFormData.register}
            errors={useFormData.errors}
            onboardingCallDate={onboardingCallDate}
            upgradeAccountInfo={upgradeAccountInfo}
            isNewTLMCAccessible={isNewTLMCAccessible}
            keapAccount={keapAccount}
          />
        )}
      </div>
    </div>
  )
}
